import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 中国台湾
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} 版權所有',
    },
    auth: {
        login: '登入',
        username: '使用者名稱',
        username_placeholder: '請輸入使用者名稱',
        password: '密碼',
        password_placeholder: '請輸入密碼',
        code: '驗證碼',
        code_placeholder: '請輸入驗證碼',
        logout: '登出',
        logout_success: '已成功登出',
        day: '天',
        password_expiration: '密碼已過期，請立即更改',
        expire: '密碼剩餘有效天數',
        conseils:
            '必須包含大寫字母、小寫字母、數字及特殊符號（{msg}）。密碼長度需介於 8 至 16 個字元之間。',
        brand_Selection: '品牌選擇',
        unread_notices: '未讀通知',
        new_cases: '新案件',
        unanswered_cases: '未回覆案件',
        overdue_cases: '逾期案件',
    },
    button: {
        query: '查詢',
        editing_position: '編輯職位',
        show_theme_editor: '顯示／隱藏主題編輯器',
        change_password: '變更密碼',
        old_password: '舊密碼',
        new_password: '新密碼',
        confirm_password: '確認密碼',
        button: '按鈕',
        about: '關於',
        back: '返回',
        go: '確定',
        home: '首頁',
        confirm: '確認',
        modify: '修改',
        edit: '編輯',
        new: '新增',
        cancel: '取消',
        close: '關閉',
        search: '搜尋',
        reset: '重設',
        delete: '刪除',
        add: '新增',
        collapse: '收合',
        expand: '展開',
        download_template: '下載範本',
        batch_import: '批次匯入',
        import: '匯入',
        export: '匯出',
        export_fail: '匯入失敗',
        detailed: '詳細',
        details: '詳情',
        download: '下載',
        toView: '檢視',
        toViews: '檢視圖片',
        uploadAttachments: '上傳附件',
        selectFile: '選擇檔案',
        fillingInstructions: '填寫說明',
        release: '發布',
        release_recall: '撤回發布',
        save: '儲存',
        send: '傳送',
        tips: '提示',
        send_back: '退回',
        examine: '審核',
        void: '作廢',
        more: '更多',
        refresh: '重新整理',
        selects: '選擇',
        serial_number: '序號',
        upload_progress: '上傳進度',
        invalid: '無效',
        daily_record: '每日紀錄',
        operation_type: '操作類型',
        field_name: '欄位名稱',
        edit_role: '編輯角色',
        user_role: '選擇角色',
        assignment_role: '角色',
        post: '職位',
        sending: '傳送中...',
        reset_password: '重設密碼',
        display_or_not: '是否顯示',
        document: '文件',
        specificTemplates: '專用範本',
        transferOrder: '轉移訂單',
        forwarding: '轉發',
        one_click_notification: '一鍵通知',
        english_export: '英文匯出',
        oneclick_download: '一鍵下載',
        passwordmsga: '必須包含大寫字母、小寫字母、數字及特殊符號（@\\$!_~\\&*）',
        passwordmsgb: '密碼長度需介於 8 至 16 個字元之間',
        passwordmsgc: '不得與最近六次使用的密碼相同',
        export_file_list: '匯出檔案清單',
        personal_center: '個人中心',
        upload_list: '上傳清單',
        clear_completed: '清除已完成項目',
    },
    radio: {
        enabled: '啟用',
        disabled: '停用',
        catalogue: '目錄',
        individual: '個別',
        all: '全部',
        yes: '是',
        no: '否',
    },
    dropdown: {
        close_others: '關閉其他',
        close_right: '關閉右側',
        close_left: '關閉左側',
    },
    table: {
        action: '操作',
        explain: '說明',
        fileName: '檔案名稱',
        size: '大小（MB）',
        uploader: '上傳者',
        uploadTime: '上傳日期',
        system: '系統',
        caption: '標題',
        categorization: '分類',
        link: '連結',
        forwarding_time: '轉發日期',
        forwarder: '轉發人',
        send_to: '傳送至',
        mode: '模式',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `第 ${named('number')} 頁`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `共 ${named('number')} 筆資料`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) => `共 ${named('number')} 輛車`,
    },
    confirm: {
        confirm_deletion: '確定要刪除嗎？',
        confirm_void: '確定要作廢嗎？',
        confirm_release: '確定要發布嗎？',
        ack: '確認',
        cancel: '取消',
        non_records: '請至少選擇一筆資料',
    },
    request: {
        failed_placeholder: '請求失敗 – 伺服器錯誤',
        success_placeholder: '請求成功',
        auth: {
            login_success: '登入成功',
        },
        error: {
            '404': '找不到資源',
            '403': '權限不足',
        },
    },
    page: {
        global: {
            page_search: '頁面內搜尋',
        },
        error: {
            not_found: '頁面不存在',
            not_found_des: '此處無任何內容',
            auth_failed: '權限不足',
            auth_failed_des: '此頁面禁止存取',
            file_format_error: '檔案格式無效！',
            preview_failed: '預覽失敗！檔案可能已損毀！',
        },
        homepage: {
            homepage: homepage.homepage.zhTW,
        },
        system: {
            menu: system.menu.zhTW,
            dict: system.dict.zhTW,
            dept: system.dept.zhTW,
            role: system.role.zhTW,
            user: system.user.zhTW,
        },
        info: {
            announcement: Info.announcement.announcement.zhTW,
            document: Info.document.document.zhTW,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.zhTW,
                recallActivity: tech.quality.recallActivity.zhTW,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.zhTW,
            },
            management: {
                inquiryOd: tech.management.inquiry.zhTW,
                permission: tech.management.permission.zhTW,
                onSiteSupportHq: tech.management.onSiteSupport.zhTW,
                progHistoryHq: tech.management.progHistory.zhTW,
                salesRecordHq: tech.management.salesRecord.zhTW,
                vehicleInfoHq: tech.management.vehicleInfo.zhTW,
                claimHq: tech.management.claim.zhTW,
                filterHq: tech.management.filter.zhTW,
                newCarlssue: tech.management.newCarIssue.zhTW,
                newCarDefinition: tech.management.newCarDefinition.zhTW,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.zhTW,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.zhTW,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.zhTW,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.zhTW,
        },
        statistics: statistics.inquiryStatistics.zhTW,
        systemClassifyA: statistics.systemClassifyA.zhTW,
        systemClassifyB: statistics.systemClassifyB.zhTW,
        engineerStatistics: statistics.engineerStatistics.zhTW,
        defectivePart: statistics.defectivePart.zhTW,
        replyInquiryStatistics: statistics.replyInquiryStatistics.zhTW,
        passRateStatistics: statistics.passRateStatistics.zhTW,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.zhTW,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.zhTW,
        customsClearance135Rate: statistics.customsClearance135Rate.zhTW,
        accumulatedClosureRate: statistics.accumulatedClosureRate.zhTW,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.zhTW,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.zhTW,
    },
    validation: {
        common: {
            required: '此欄位為必填',
            numeric: '必須為整數',
            decimal: '必須為數字',
            positive_interger: '必須為正整數',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `最多 ${named('number')} 位數`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `最多允許 ${named('number')} 個字元`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `超過最大字元數限制（${named('number')}）`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `至少需 ${named('number')} 個字元`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `必須正好為 ${named('number')} 個字元`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `不得大於 ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) => `不得小於 ${named('number')}`,
            up_to_2_decimal_places: '最多保留兩位小數',
            retain_up: '整數部分最多 10 位，小數部分最多 2 位',
            retain_ups: '整數部分最多 11 位，小數部分最多 4 位',
            input_number: '僅可輸入阿拉伯數字',
            only_number_a: '僅可輸入英文字母或數字',
            translate: '僅可輸入英文字母',
            positive_integer: '至少需填寫一個欄位',
            at_least_one: '至少需填寫一項',
        },
        tip: {
            incomplete_information: '資料不完整',
        },
    },
    import: {
        template_file: '範本檔案',
        browse: '瀏覽',
        download_template: '下載範本',
        no_file_selected: '尚未選擇檔案',
        incorrect_file_type: '檔案類型錯誤',
        exceed: '超出限制',
        upload_success: '上傳成功',
        upload_fail: '上傳失敗',
        again_upload: '僅支援 jpg、png、bmp 或 gif 格式的圖片，請重新上傳。',
        attachmentUpload: '上傳附件',
        otherAttachmentUpload: '上傳其他附件',
        supportedFormats: '支援格式',
        preview: '預覽',
    },
    export: {
        noDataToExport: '無資料可供匯出',
    },
    select: {
        all: '全部',
    },
    checkbox: {
        select_all: '全選',
    },
    dialog: {
        error_message: '錯誤訊息',
        one_year: '一次最多僅可匯出一年內的資料',
    },
    ymd: {
        year: '年',
        month: '月',
        day: '日',
        week: '週',
        january: '一月',
        february: '二月',
        march: '三月',
        april: '四月',
        may: '五月',
        june: '六月',
        july: '七月',
        august: '八月',
        september: '九月',
        october: '十月',
        november: '十一月',
        december: '十二月',
    },
};
